<button #button [attr.data-testid]="testId()" [disabled]="isDisabled" [ngClass]="buttonCategory" (click)="add.emit()">
  <mat-icon class="product-icon" [svgIcon]="iconName" />
  {{ buttonText }}
  @if (buttonCategory === 'primary') {
    <mat-icon class="add-icon" [svgIcon]="IconNames.ice_add" />
  }
</button>
